import Vue from 'vue'
import VueRouter from 'vue-router';
import Home from '../views/Home';
import CollapsedRegister from "@/components/CollapsedRegister";
import FundingCampaign from "@/views/FundingCampaign";
import FundingCampaignB from "@/views/FundingCampaignB";
import SwisetPlans from "@/views/SwisetPlans";
import CollapsedNotification from "@/components/CollapsedNotification";
import GeneralLanding from "@/views/GeneralLanding";
import FundingCampaignC from "@/views/FundingCampaignC";
import OpenOnDesktop from "@/views/OpenOnDesktop";
import VoteIndex from "@/views/Awards/VoteIndex";
import CategoryNominees from "@/views/Awards/views/CategoryNominees";
import VoteHome from "@/views/Awards/views/VoteHome";
import AwardCategories from "@/views/Awards/views/AwardCategories";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/register',
        name: 'collapse-register',
        component: CollapsedRegister,
    },
    {
        path: '/open-on-desktop',
        name: 'open-on-desktop',
        component: OpenOnDesktop,
    },
    {
        path:'/campaign-futures',
        name: 'campaign-futures',
        component: FundingCampaign,
    },
    {
        path: '/campaign-futures-tournament',
        name: 'campaign-futures-tournament',
        component: FundingCampaignB,
    },
    {
        path: '/campaign-futures-c',
        name: 'campaign-futures-c',
        component: FundingCampaignC
    },
    {
        path: '/plans',
        name: 'plans',
        component: SwisetPlans,
    },
    {
        path: '/notification',
        name: 'notification',
        component: CollapsedNotification,
        props: true,
    },
    {
        path: '/general-landing',
        name: 'general-landing',
        component: GeneralLanding,
    },
    {
        path: '/vote',
        name: 'vote',
        component: VoteIndex,
        children: [
            {
                path: '',
                name: 'home',
                component: VoteHome,
            },
            {
                path: 'award-categories',
                name: 'categories',
                component: AwardCategories,
                props: true,
            },
            {
                path: 'category-nominees',
                name: 'nominees',
                component: CategoryNominees,
                props: true,
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;
